module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAVNJREFUKFON0j8sA3EUB/Dv+2m1kfaqoajc1WaxCYnEwGoQESFxXcSfxCSRsDVBpKMuBgmDqb1GwmQzMIuBWBgYeicR/9JeJVXae1JChJ72jS/55Pd73/cIVRTzkkjqsVUmGmXmU6rCIJ6SNgCeJcJRUG4YqIg03TdjsbUJwrnH7eodCjxk/0VJw9tetHAGoiLVOLvU1seL0s9sETOTZkiHzOgjYFINZbe/RrFFCd03zWxtgWg/rJiDP2cvi/Zum5tyr7lLgN2oFR3hlsx1RRRPSTGA5wXR8rhirvxOmLSUFGFgCoSYqpjru/eNwfxL/grAswO+tjHFyP1BcV06BnP3RyoCE8zUCeY5EiKiyplouT3Szo0/VLAKJ8wIAGQCXAuitzqPCA370+myqNTU9Pp+RvGAGY7PF8WaKmcW7K7lO72E7l1kRpQIdy5y9ozIT4Ydegdj1noyoe4r7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/learnmodel/V@2x.png
// module id = cjAA
// module chunks = 96